const ColorScheme = {
    'sf-gray-50': '#F6F6F6',
    'sf-gray-100': '#EDEDED',
    'sf-gray-200': '#DEDEDE',
    'sf-gray-300': '#C9C9C9',
    'sf-gray-400': '#A5A5A5',
    'sf-gray-500': '#808080',
    'sf-gray-600': '#666666',
    'sf-gray-700': '#4D4D4D',
    'sf-gray-800': '#333333',
    'sf-gray-900': '#252525',
    'sf-gray-1000': '#1A1919',
    'sf-primary-100': '#E9F5FF',
    'sf-primary-200': '#A8CEF8',
    'sf-primary-300': '#69A9EE',
    'sf-primary-500': '#188DED',
    'sf-primary-700': '#0E7FDC',
    'sf-positive-100': '#E6FBF5',
    'sf-positive-300': '#7AE9CB',
    'sf-positive-500': '#00CC96',
    'sf-neutral-100': '#FFF8E7',
    'sf-neutral-300': '#FFD68E',
    'sf-neutral-500': '#F7B748',
    'sf-negative-100': '#FEEBEC',
    'sf-negative-300': '#FEA1AC',
    'sf-negative-400': '#FF7A8B',
    'sf-negative-500': '#F5445A',
    'sf-negative-600': '#E73148'
};

export default ColorScheme;
